import { render, staticRenderFns } from "./OrderRecord.vue?vue&type=template&id=00ea096a&scoped=true&"
import script from "./OrderRecord.vue?vue&type=script&lang=js&"
export * from "./OrderRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ea096a",
  null
  
)

export default component.exports